// extracted by mini-css-extract-plugin
export default {"meetingsAndCalls":"MeetingsAndCalls_meetingsAndCalls__7xmbd","meetingsAndCallsCol":"MeetingsAndCalls_meetingsAndCallsCol__bonFq"};